/*
  * Since Faq accordions are inited in the old repo with jQuery ( which cat be modified ),
  * this opens up the accordion if found on url.
  *
  * This is used in header search FAQ links
  */
export default function faqAccordion() {
  setTimeout(() => {
    const hash = window.location.hash;
    if (hash) {
      const accordionId = hash.substring(1);
      const accordionElement = document.getElementById(accordionId);
      const answer = accordionElement?.querySelector('.answer')

      if (accordionElement && answer) {
        answer.style.display = 'block'
      }
    }
  }, 100);
}
